import { Injectable } from '@angular/core';
import { SharedService } from '../../../services/shared.service';
import { LocalStorageService } from 'ngx-webstorage';
import { environment } from '../../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class AlQuoteService {

  constructor(private sharedService: SharedService,private sessionSt: LocalStorageService) { }

  // Get Agreed Questions
  getAgreedQues(company_id) {
    return this.sharedService.getAPI('staticdata/alpaca_agreed_questions/' + company_id);
  }

  // Get All Static Data
  getStaticData() {
    return this.sharedService.getAPI('staticdata/get_alpaca_static_data');
  }


  // Save Quote
  saveQuote(data){
    return this.sharedService.postAPI('alpaca/quote', data);
  }
  // POSTCODE LOOKUP
  getAddressPostcodeLookup(postcode) {
    return this.sharedService.getOtherAPI(environment.ADDRESSLOOKUP_API_URL + postcode + '?api-key=' + environment.ADDRESSLOOKUP_API_KEY + '&expand=true&fuzzy=true');
  }

  // Get StatementOFFact Data
  getStatementOfFacts() {
    return this.sharedService.getAPI('staticdata/alpaca_statement_of_fact/' + environment.ALPACA_ID + '/100');
  }

  // Get Quote Details By ID
  getQuoteDetails(quote_id) {
    return this.sharedService.getAPI('alpaca/quote/details/'+quote_id);
  }

  // Convert To Policy
  convertToPolicy(data) {
    return this.sharedService.postAPI('alpaca/quote/convert_to_policy', data);
  }

   // Get All Brokers
   getBrokers() {
    return this.sharedService.getAPI('companies/allbrokersbyloggedinuser/' + this.sessionSt.retrieve('userInfo').id);
  }

  // Get Notes --- remove later
  getNotes(quote_id) {
    return this.sharedService.getAPI('quote/notes/list/' + quote_id);
  }

   // Update Quote Status -- remove later
   updateQuoteStatus(data) {
    return this.sharedService.postAPI('quote/status', data);
  }
}

